import React from "react";
import "../../index.css";
import { rippleEffect } from "../../Utils/constants";
import "./Button.css";

function Button(props) {
  const getClassName = () => {
    let className = "";
    if (props.disabled === true) {
      className += `inherit-parent-width ${
        props.variant === "transparent" ? "" : "disabled-button-background"
      } ${
        getComputedStyle(document.documentElement).getPropertyValue(
          "--primaryColor"
        ) === "#F3F3F3"
          ? "font-color-white"
          : "font-color-black"
      }  font-size-small cursor-not-allowed max-height-32px cursor-no-drop`;
      className += ` ${
        !props.boxShadow || props.disabled
          ? "box-shadow-none"
          : "box-shadow-default"
      }`;
      className += ` ${props.className}`;
      return className;
    }

    className += `inherit-parent-width font-size-small cursor-pointer `;
    // variant
    switch (props.variant) {
      case "secondary": {
        className +=
          "font-color-tertiaryColor6 background-white border-1px-e5e5e5 max-height-32px";
        break;
      }

      case "danger": {
        className +=
          "font-color-danger button-background-transparent danger-bordered-button-background font-color-danger max-height-32px";
        break;
      }

      case "transparent": {
        className += ` ${
          props.fontColor || "font-color-tertiaryColor6"
        } button-background-transparent max-height-32px`;
        break;
      }

      case "primaryBorder": {
        className +=
          "font-color-tertiaryColor background-white bordered-button-background  max-height-32px";
        break;
      }

      case "filter": {
        className +=
          "background-color-secondary font-color-secondaryColor  max-height-32px";
        break;
      }

      default: {
        className += `background-color-secondary ${
          getComputedStyle(document.documentElement).getPropertyValue(
            "--primaryColor"
          ) === "#F3F3F3"
            ? "font-color-white"
            : "font-color-black"
        } max-height-32px`;
        break;
      }
    }
    className += ` ${
      props.boxShadow === false ? "box-shadow-none" : "box-shadow-default"
    }`;
    className += ` ${props.className}`;
    return className;
  };

  const DefaultButton = () => {
    return (
      <button
        style={props.style}
        data-cy={props["data-cy"] ? props["data-cy"] : "button-component"}
        type={props.type}
        className={getClassName()}
        onClick={(event) => {
          rippleEffect(event);
          if (props.loading === true) {
            return;
          }
          if (typeof props.onClick === "function") {
            props.onClick(event);
          }
        }}
        disabled={props.disabled || props.loading}
      >
        {props.loading !== true ? (
          <div className="display-flex flex-justify-content-center flex-align-items-center">
            {props.icon && (
              <div
                style={{
                  paddingTop: "1px"
                }}
              >
                {props.icon}
              </div>
            )}
            <div
              style={{
                fontWeight: "600"
              }}
              className={`${
                props.icon
                  ? "padding-left-default white-space-nowrap"
                  : "white-space-nowrap"
              }`}
            >
              {props.text}
            </div>
          </div>
        ) : (
          <div className="flex-place-children-page-center padding-vertical-small margin-top-smaller">
            <div
              className={`${
                props.disabled
                  ? "dot-pulse-dark"
                  : props.variant === "primaryBorder"
                  ? "dot-pulse-primary"
                  : "dot-pulse"
              }`}
            />
          </div>
        )}
      </button>
    );
  };
  return (
    <React.Fragment key={props.buttonKey}>
      <DefaultButton />
    </React.Fragment>
  );
}

export default Button;
